import React, { useState } from "react";
import { FaChevronLeft } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { FaComments } from "react-icons/fa";
import { AiFillLike } from "react-icons/ai";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

export default function BlogPosts() {
  const [posts, setPosts] = useState({
    postList: [
      {
        id: 1,
        title: "تفاوت اکانت ها",
        description:
          "در این پست سعی داریم تفاوت ها و کاربرد های اکانت کرکی و پریمیوم را بررسی کنیم",
        img: "./images/box1.webp",
        comments: 2,
        likes: 4,
      },
      {
        id: 2,
        title: "2تفاوت اکانت ها",
        description:
          "2در این پست سعی داریم تفاوت ها و کاربرد های اکانت کرکی و پریمیوم را بررسی کنیم",
        img: "./images/box2.webp",
        comments: 2,
        likes: 4,
      },
      {
        id: 3,
        title: "3تفاوت اکانت ها",
        description:
          "3در این پست سعی داریم تفاوت ها و کاربرد های اکانت کرکی و پریمیوم را بررسی کنیم",
        img: "./images/box3.webp",
        comments: 2,
        likes: 4,
      },
      {
        id: 4,
        title: "4تفاوت اکانت ها",
        description:
          "4در این پست سعی داریم تفاوت ها و کاربرد های اکانت کرکی و پریمیوم را بررسی کنیم",
        img: "./images/box1.webp",
        comments: 2,
        likes: 4,
      },
      {
        id: 5,
        title: "5تفاوت اکانت ها",
        description:
          "5در این پست سعی داریم تفاوت ها و کاربرد های اکانت کرکی و پریمیوم را بررسی کنیم",
        img: "./images/box3.webp",
        comments: 2,
        likes: 4,
      },
      {
        id: 6,
        title: "6تفاوت اکانت ها",
        description:
          "5در این پست سعی داریم تفاوت ها و کاربرد های اکانت کرکی و پریمیوم را بررسی کنیم",
        img: "./images/box2.webp",
        comments: 13,
        likes: 4,
      },
      {
        id: 7,
        title: "7تفاوت اکانت ها",
        description:
          "5در این پست سعی داریم تفاوت ها و کاربرد های اکانت کرکی و پریمیوم را بررسی کنیم",
        img: "./images/box3.webp",
        comments: 21,
        likes: 4,
      },
      {
        id: 8,
        title: "8تفاوت اکانت ها",
        description:
          "5در این پست سعی داریم تفاوت ها و کاربرد های اکانت کرکی و پریمیوم را بررسی کنیم",
        img: "./images/box1.webp",
        comments: 10,
        likes: 4,
      },
    ],
    newPosts: [],
    popularPosts: [],
    isNewPosts: false,
    isPopularPosts: false,
  });
  const handleNewPosts = () => {
    // sort and set posts to new and popular
    let newPostsArray = [...posts.postList]
      .splice(posts.postList.length - 5, posts.postList.length)
      .reverse();
    setPosts((prev) => ({
      ...prev,
      newPosts: newPostsArray,
    }));
    setPosts((prev) => ({
      ...prev,
      isNewPosts: true,
    }));
    if (posts.isPopularPosts) {
      setPosts((prev) => ({
        ...prev,
        isPopularPosts: !prev.isPopularPosts,
      }));
    }
  };
  const handlePopularPosts = () => {
    // popular array - 5 پست آخر که بیشترین کامنت را دارند
    let popularPostsArray = [...posts.postList]
      .sort((a, b) => b.comments - a.comments) // مرتب‌سازی بر اساس تعداد کامنت (نزولی)
      .slice(0, 5); // گرفتن 5 پست اول (که بیشترین کامنت را دارند)

    setPosts((prev) => ({
      ...prev,
      popularPosts: popularPostsArray,
    }));
    setPosts((prev) => ({
      ...prev,
      isPopularPosts: true,
    }));
    if (posts.isNewPosts) {
      setPosts((prev) => ({
        ...prev,
        isNewPosts: !prev.isNewPosts,
      }));
    }
  };
  return (
    <>
      <section className="z-50 -mt-32 relative px-4">
        <div
          className="container text-white relative z-10"
          style={{ direction: "rtl" }}
        >
          {/* Top Title Blog */}
          <div className="flex justify-between items-center relative z-20">
            {/* Right side title */}
            <div className="md:text-2xl text-base font-DanaDemiBold relative z-30">
              مطالب وبلاگ
            </div>
            {/* Left side Buttons */}
            <div className="flex md:gap-x-7 gap-x-2 child:cursor-pointer items-center relative z-30 transition-colors">
              <div
                className={`relative md:leading-10 text-xs md:text-lg font-DanaMedium cursor-pointer`}
                onClick={handleNewPosts}
                style={{ direction: "rtl" }}
              >
                <span
                  className={`transition-colors duration-300 ${
                    posts.isNewPosts ? "text-[#D4FE00]" : ""
                  }`}
                  style={{ direction: "rtl" }}
                >
                  جدید ترین
                </span>
                <span
                  className={`absolute right-0 bottom-0 h-0.5 bg-[#D4FE00] transition-all duration-500 ${
                    posts.isNewPosts ? "w-full" : "w-0"
                  }`}
                  style={{
                    borderRadius: "2px",
                    direction: "rtl",
                  }}
                ></span>
              </div>
              <div
                className={`relative md:leading-10 text-xs md:text-lg font-DanaMedium cursor-pointer`}
                onClick={handlePopularPosts}
                style={{ direction: "rtl" }}
              >
                <span
                  className={`transition-colors duration-300 ${
                    posts.isPopularPosts ? "text-[#D4FE00]" : ""
                  }`}
                  style={{ direction: "rtl" }}
                >
                  محبوب ترین
                </span>
                <span
                  className={`absolute right-0 bottom-0 h-0.5 bg-[#D4FE00] transition-all duration-500 ${
                    posts.isPopularPosts ? "w-full" : "w-0"
                  }`}
                  style={{
                    borderRadius: "2px",
                    direction: "rtl",
                  }}
                ></span>
              </div>
              <Link
                to="/"
                className="flex gap-x-2 items-center hover:text-[#D1D1D1] transition-colors group active:text-[#D4FE00] text-xs md:text-lg"
              >
                بیشتر بخوانید
                <FaChevronLeft className="transition-transform duration-200 group-hover:-translate-x-1.5" />
              </Link>
            </div>
          </div>

          {/* Blog Boxes */}
          <div className=" ">
            {posts.postList && (
              <Swiper
                spaceBetween={20}
                slidesPerView={3}
                breakpoints={{
                  0: {
                    slidesPerView: 1,
                  },
                  601: {
                    slidesPerView: 2,
                  },
                  1024: {
                    slidesPerView: 3,
                  },
                }}
                onSlideChange={() => console.log("slide change")}
                onSwiper={(swiper) => console.log(swiper)}
                className="mt-5  font-DanaDemiBold  child:rounded-3xl bg-[#13151D] rounded-3xl"
              >
                {(posts.isNewPosts &&
                  posts.newPosts.map((post) => {
                    return (
                      <SwiperSlide className="rounded-3xl bg-[#181B24]">
                        {" "}
                        <div className="">
                          <div className="overflow-hidden w-full h-[240px] rounded-3xl mb-5">
                            <img
                              src={post.img}
                              alt=""
                              className="w-full h-full p-1.5 rounded-3xl transition-transform duration-300 hover:scale-105 object-cover cursor-pointer"
                            />
                          </div>
                          <Link to="//premium" className=" text-lg px-4 ">
                            {post.title}
                          </Link>
                          <p className="text-[#717373] mt-7 px-4 text-justify line-clamp-2">
                            {post.description}
                          </p>

                          <div className="mt-5 flex justify-between w-full px-4 pb-4 text-[#717373]">
                            {/* Right Learn More info */}
                            <div>
                              <Link
                                to="/"
                                className="flex gap-x-2 items-center hover:text-[#D1D1D1] transition-colors group"
                              >
                                بیشتر بخوانید
                                <FaChevronLeft className="transition-transform duration-200 group-hover:-translate-x-1.5" />
                              </Link>
                            </div>
                            {/* Left icons to click - Comment and Like Button */}

                            <div className="flex gap-x-4 child:flex child:gap-x-2">
                              <div>
                                <span>{post.comments}</span>
                                <FaComments className="" />
                              </div>
                              <div>
                                <span>{post.likes}</span>
                                <AiFillLike />
                              </div>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                    );
                  })) ||
                  (posts.isPopularPosts &&
                    posts.popularPosts.map((post) => {
                      return (
                        <SwiperSlide className="rounded-3xl bg-[#181B24]">
                          {" "}
                          <div className="">
                            <div className="overflow-hidden w-full h-[240px] rounded-3xl mb-5">
                              <img
                                src={post.img}
                                alt=""
                                className="w-full h-full p-1.5 rounded-3xl transition-transform duration-300 hover:scale-105 object-cover cursor-pointer"
                              />
                            </div>
                            <Link to="//premium" className=" text-lg px-4 ">
                              {post.title}
                            </Link>
                            <p className="text-[#717373] mt-7 px-4 text-justify line-clamp-2">
                              {post.description}
                            </p>

                            <div className="mt-5 flex justify-between w-full px-4 pb-4 text-[#717373]">
                              {/* Right Learn More info */}
                              <div>
                                <Link
                                  to="/"
                                  className="flex gap-x-2 items-center hover:text-[#D1D1D1] transition-colors group"
                                >
                                  بیشتر بخوانید
                                  <FaChevronLeft className="transition-transform duration-200 group-hover:-translate-x-1.5" />
                                </Link>
                              </div>
                              {/* Left icons to click - Comment and Like Button */}

                              <div className="flex gap-x-4 child:flex child:gap-x-2">
                                <div>
                                  <span>{post.comments}</span>
                                  <FaComments className="" />
                                </div>
                                <div>
                                  <span>{post.likes}</span>
                                  <AiFillLike />
                                </div>
                              </div>
                            </div>
                          </div>
                        </SwiperSlide>
                      );
                    })) ||
                  posts.postList.map((post) => {
                    return (
                      <SwiperSlide className="rounded-3xl bg-[#181B24]">
                        {" "}
                        <div className="">
                          <div className="overflow-hidden w-full h-[240px] rounded-3xl mb-5">
                            <img
                              src={post.img}
                              alt=""
                              className="w-full h-full p-1.5 rounded-3xl transition-transform duration-300 hover:scale-105 object-cover cursor-pointer"
                            />
                          </div>
                          <Link to="//premium" className=" text-lg px-4 ">
                            {post.title}
                          </Link>
                          <p className="text-[#717373] mt-7 px-4 text-justify line-clamp-2">
                            {post.description}
                          </p>

                          <div className="mt-5 flex justify-between w-full px-4 pb-4 text-[#717373]">
                            {/* Right Learn More info */}
                            <div>
                              <Link
                                to="/"
                                className="flex gap-x-2 items-center hover:text-[#D1D1D1] transition-colors group"
                              >
                                بیشتر بخوانید
                                <FaChevronLeft className="transition-transform duration-200 group-hover:-translate-x-1.5" />
                              </Link>
                            </div>
                            {/* Left icons to click - Comment and Like Button */}

                            <div className="flex gap-x-4 child:flex child:gap-x-2">
                              <div>
                                <span>{post.comments}</span>
                                <FaComments className="" />
                              </div>
                              <div>
                                <span>{post.likes}</span>
                                <AiFillLike />
                              </div>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                    );
                  })}
              </Swiper>
            )}
          </div>
        </div>
      </section>
    </>
  );
}
